import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRefresh = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M6.54 28.127 2.667 32V21.333h10.666L9.43 25.238c2.031 1.46 4.19 2.159 6.571 2.159 3.111 0 5.778-1.111 8.063-3.333 2.223-2.286 3.334-4.953 3.334-8.064h4a15.4 15.4 0 0 1-4.508 10.92A15.435 15.435 0 0 1 16 31.398c-3.524 0-6.635-1.08-9.46-3.27zM4.603 16h-4c0-4.254 1.714-8.095 4.476-10.889A15.404 15.404 0 0 1 16 .603c3.524 0 6.635 1.08 9.46 3.27L29.333 0v10.667H18.667l3.904-3.905C20.54 5.302 18.381 4.603 16 4.603c-3.111 0-5.778 1.111-8.064 3.334C5.714 10.222 4.603 12.889 4.603 16z" /></g></svg>;
export default SvgRefresh;